/**
 * Names of icons to be used like `` <i className={`fe icon-${IconClass.zap}`} />``.
 *
 * @note Most of these are from feather-icons, but custom SVGs are added using `customMaskIcon` in `legacy.scss`.
 */
export enum IconClass {
  activity = 'activity',
  ai = 'ai',
  airplay = 'airplay',
  alertCircle = 'alert-circle',
  alertOctagon = 'alert-octagon',
  alertTriangle = 'alert-triangle',
  alignCenter = 'align-center',
  alignJustify = 'align-justify',
  alignLeft = 'align-left',
  alignRight = 'align-right',
  anchor = 'anchor',
  aperture = 'aperture',
  arrowDown = 'arrow-down',
  arrowDownLeft = 'arrow-down-left',
  arrowDownRight = 'arrow-down-right',
  arrowLeft = 'arrow-left',
  arrowRight = 'arrow-right',
  arrowUp = 'arrow-up',
  arrowUpLeft = 'arrow-up-left',
  arrowUpRight = 'arrow-up-right',
  atSign = 'at-sign',
  award = 'award',
  barChart = 'bar-chart',
  barChart2 = 'bar-chart-2',
  battery = 'battery',
  batteryCharging = 'battery-charging',
  bell = 'bell',
  bellOff = 'bell-off',
  bluetooth = 'bluetooth',
  bold = 'bold',
  book = 'book',
  bookmark = 'bookmark',
  // Custom icon.
  bot = 'bot',
  box = 'box',
  briefcase = 'briefcase',
  calendar = 'calendar',
  camera = 'camera',
  cameraOff = 'camera-off',
  cast = 'cast',
  check = 'check',
  checkCircle = 'check-circle',
  checkSquare = 'check-square',
  chevronDown = 'chevron-down',
  chevronLeft = 'chevron-left',
  chevronRight = 'chevron-right',
  chevronUp = 'chevron-up',
  chevronsDown = 'chevrons-down',
  chevronsLeft = 'chevrons-left',
  chevronsRight = 'chevrons-right',
  chevronsUp = 'chevrons-up',
  chrome = 'chrome',
  circle = 'circle',
  clipboard = 'clipboard',
  clock = 'clock',
  cloud = 'cloud',
  cloudDrizzle = 'cloud-drizzle',
  cloudLightning = 'cloud-lightning',
  cloudOff = 'cloud-off',
  cloudRain = 'cloud-rain',
  cloudSnow = 'cloud-snow',
  codepen = 'codepen',
  command = 'command',
  compass = 'compass',
  copy = 'copy',
  cornerDownLeft = 'corner-down-left',
  cornerDownRight = 'corner-down-right',
  cornerLeftDown = 'corner-left-down',
  cornerLeftUp = 'corner-left-up',
  cornerRightDown = 'corner-right-down',
  cornerRightUp = 'corner-right-up',
  cornerUpLeft = 'corner-up-left',
  cornerUpRight = 'corner-up-right',
  cpu = 'cpu',
  creditCard = 'credit-card',
  crop = 'crop',
  crosshair = 'crosshair',
  delete = 'delete',
  disc = 'disc',
  download = 'download',
  downloadCloud = 'download-cloud',
  droplet = 'droplet',
  edit = 'edit',
  edit2 = 'edit-2',
  edit3 = 'edit-3',
  externalLink = 'external-link',
  eye = 'eye',
  eyeOff = 'eye-off',
  facebook = 'facebook',
  fastForward = 'fast-forward',
  feather = 'feather',
  file = 'file',
  fileMinus = 'file-minus',
  filePlus = 'file-plus',
  fileText = 'file-text',
  film = 'film',
  filter = 'filter',
  flag = 'flag',
  folder = 'folder',
  gitBranch = 'git-branch',
  gitMerge = 'git-merge',
  github = 'github',
  gitlab = 'gitlab',
  globe = 'globe',
  graphql = 'graphql',
  grid = 'grid',
  hash = 'hash',
  headphones = 'headphones',
  heart = 'heart',
  helpCircle = 'help-circle',
  home = 'home',
  image = 'image',
  inbox = 'inbox',
  info = 'info',
  instagram = 'instagram',
  italic = 'italic',
  layers = 'layers',
  layout = 'layout',
  lifeBuoy = 'life-buoy',
  link = 'link',
  link2 = 'link-2',
  list = 'list',
  loader = 'loader',
  lock = 'lock',
  logIn = 'log-in',
  logOut = 'log-out',
  mail = 'mail',
  map = 'map',
  mapPin = 'map-pin',
  maximize = 'maximize',
  maximize2 = 'maximize-2',
  menu = 'menu',
  messageCircle = 'message-circle',
  messageSquare = 'message-square',
  mic = 'mic',
  micOff = 'mic-off',
  minimize = 'minimize',
  minimize2 = 'minimize-2',
  minus = 'minus',
  minusCircle = 'minus-circle',
  minusSquare = 'minus-square',
  monitor = 'monitor',
  moon = 'moon',
  moreHorizontal = 'more-horizontal',
  moreVertical = 'more-vertical',
  move = 'move',
  music = 'music',
  navigation = 'navigation',
  navigation2 = 'navigation-2',
  octagon = 'octagon',
  package = 'package',
  paperclip = 'paperclip',
  pause = 'pause',
  pauseCircle = 'pause-circle',
  percent = 'percent',
  phone = 'phone',
  phoneCall = 'phone-call',
  phoneForwarded = 'phone-forwarded',
  phoneIncoming = 'phone-incoming',
  phoneMissed = 'phone-missed',
  phoneOff = 'phone-off',
  phoneOutgoing = 'phone-outgoing',
  pieChart = 'pie-chart',
  play = 'play',
  playCircle = 'play-circle',
  plus = 'plus',
  plusCircle = 'plus-circle',
  plusSquare = 'plus-square',
  pocket = 'pocket',
  power = 'power',
  printer = 'printer',
  radio = 'radio',
  recycle = 'recycle',
  refreshCcw = 'refresh-ccw',
  refreshCw = 'refresh-cw',
  repeat = 'repeat',
  rewind = 'rewind',
  rotateCcw = 'rotate-ccw',
  rotateCw = 'rotate-cw',
  save = 'save',
  scissors = 'scissors',
  search = 'search',
  server = 'server',
  settings = 'settings',
  share = 'share',
  share2 = 'share-2',
  shield = 'shield',
  shoppingCart = 'shopping-cart',
  shuffle = 'shuffle',
  sidebar = 'sidebar',
  skipBack = 'skip-back',
  skipForward = 'skip-forward',
  slack = 'slack',
  slash = 'slash',
  sliders = 'sliders',
  smartphone = 'smartphone',
  speaker = 'speaker',
  square = 'square',
  star = 'star',
  stopCircle = 'stop-circle',
  sun = 'sun',
  sunrise = 'sunrise',
  sunset = 'sunset',
  table = 'table',
  tablet = 'tablet',
  tag = 'tag',
  target = 'target',
  thermometer = 'thermometer',
  thumbsDown = 'thumbs-down',
  thumbsUp = 'thumbs-up',
  toggleLeft = 'toggle-left',
  toggleRight = 'toggle-right',
  trash = 'trash',
  trash2 = 'trash-2',
  trendingDown = 'trending-down',
  trendingUp = 'trending-up',
  triangle = 'triangle',
  tv = 'tv',
  twitter = 'twitter',
  type = 'type',
  umbrella = 'umbrella',
  underline = 'underline',
  unlock = 'unlock',
  upload = 'upload',
  uploadCloud = 'upload-cloud',
  user = 'user',
  userCheck = 'user-check',
  userMinus = 'user-minus',
  userPlus = 'user-plus',
  userX = 'user-x',
  users = 'users',
  video = 'video',
  videoOff = 'video-off',
  voicemail = 'voicemail',
  volume = 'volume',
  volume1 = 'volume-1',
  volume2 = 'volume-2',
  volumeX = 'volume-x',
  watch = 'watch',
  wifi = 'wifi',
  wifiOff = 'wifi-off',
  wind = 'wind',
  x = 'x',
  xCircle = 'x-circle',
  xSquare = 'x-square',
  zap = 'zap',
  zoomIn = 'zoom-in',
  zoomOut = 'zoom-out'
}
